import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const TeamContext = createContext<{ params?: Routing.TeamParams }>({})

export { TeamContext }
